import {
  PASSENGER_ASSET_TYPES,
  PASSENGER_SERVICES,
  PERFORMER_CATEGORIES,
  performerText,
} from "./performerCatalog.js";

// REISOR_PHASE3A_PERFORMER_VALIDATION_V2

export function validatePerformerAsset(
  form = {},
  {
    tr,
    language = "ru",
  } = {}
) {
  const tx = (ru, uz, trText) =>
    performerText(
      language,
      ru,
      uz,
      trText
    );

  const category =
    String(
      form.performerCategory || ""
    ).toUpperCase();

  if (!PERFORMER_CATEGORIES.includes(category)) {
    return tx(
      "Выберите, что у вас есть",
      "Сизда нима борлигини танланг",
      "Sahip olduğunuz aracı seçin"
    );
  }

  if (category === "SPECIAL") {
    if (!String(form.bodyTypeOther || "").trim()) {
      return tx(
        "Выберите вид спецтехники",
        "Махсус техника турини танланг",
        "Özel ekipman türünü seçin"
      );
    }
  }

  if (category === "PASSENGER") {
    const assetType =
      String(form.assetType || "").toUpperCase();

    if (!PASSENGER_ASSET_TYPES.includes(assetType)) {
      return tx(
        "Выберите вид пассажирского транспорта",
        "Йўловчи транспорти турини танланг",
        "Yolcu aracı türünü seçin"
      );
    }

    const seats = Number(form.seats);

    if (
      !Number.isInteger(seats) ||
      seats < 1 ||
      seats > 100
    ) {
      return tx(
        "Укажите количество мест",
        "Ўриндиқлар сонини киритинг",
        "Koltuk sayısını girin"
      );
    }

    const passengerServices = Array.isArray(form.passengerServices)
      ? form.passengerServices
          .map((value) => String(value || "").toUpperCase())
          .filter((value) => PASSENGER_SERVICES.includes(value))
      : [];

    if (!passengerServices.length) {
      return tx(
        "Выберите хотя бы один вид пассажирской услуги",
        "Камида битта йўловчи хизмати турини танланг",
        "En az bir yolcu hizmeti seçin"
      );
    }
  }

  if (category !== "CARGO") return "";

  if (!form.bodyType) {
    return tr(
      "registerWizard.errors.bodyType",
      "Выберите тип кузова"
    );
  }

  if (
    form.bodyType === "Другое" &&
    !String(form.bodyTypeOther || "").trim()
  ) {
    return tr(
      "registerWizard.errors.bodyTypeOther",
      "Уточните тип кузова"
    );
  }

  const tons = Number(form.capacityTons);
  const volume = Number(form.volumeM3);

  if (!String(form.capacityTons ?? "").trim()) {
    return tr(
      "registerWizard.errors.capacityTons",
      "Укажите грузоподъёмность автомобиля"
    );
  }

  if (
    !Number.isFinite(tons) ||
    tons < 0.1 ||
    tons > 1000
  ) {
    return tr(
      "registerWizard.errors.capacityTons",
      "Проверьте грузоподъёмность автомобиля"
    );
  }

  if (!String(form.volumeM3 ?? "").trim()) {
    return tr(
      "registerWizard.errors.volumeM3",
      "Укажите объём кузова"
    );
  }

  if (
    !Number.isFinite(volume) ||
    volume <= 0 ||
    volume > 10000
  ) {
    return tr(
      "registerWizard.errors.volumeM3",
      "Проверьте объём кузова"
    );
  }

  return "";
}
